import type { CompanyInfo } from '../types';

export interface CompanyService {
    getInfo(id: string, type: string): Promise<CompanyInfo>;
}

export const CompanyService = Symbol('CompanyService');
